
import { Button, DatePicker, Drawer, message, Modal, Progress, Select, Space, Table, Tabs } from 'antd'
import styles from './index.module.scss'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import dayjs from 'dayjs'
import API, { commonApiInvoker } from '@api/api'
import { AppContext } from '@utils/AppContext'
import * as echarts from 'echarts';
import { useLocation, useNavigate }from "react-router-dom"; 
import RequirementForm from '@view/compoents/RequirementForm'
import { ArrowLeftOutlined } from '@ant-design/icons'
import eventBus from '@utils/eventBus';

const dateTypeOptions = [{
    label: '交付日期',
    value: 'delivery',
}, {
    label: '完结日期',
    value: 'completed',
}]
const deliveryTypeOptions = [{
    label: '全部交付类型',
    value: 'all',
}, {
    label: '图片',
    value: 'image',
}, {
    label: '视频',
    value: 'video',
}]

const ProgressComponent = ({deliveryNum, acceptedNum, processNum, cancelNum}) => {
    return (
        <div className={styles.ProgressComponent}>
            {/* 进行中 */}
            {acceptedNum+processNum > 0 ?
            <div className={styles.Process} style={{width: `${deliveryNum > 0 ? (acceptedNum+processNum) / deliveryNum * 100 : 0}%`}}></div> : null}
            {/* 已通过 */}
            {acceptedNum > 0 ?
            <div className={styles.Accepted} style={{width: `${deliveryNum > 0 ? acceptedNum / deliveryNum * 100 : 0}%`}}></div> : null}
        </div>
    )
}

const DashboardData = ({total, acceptedNum, processNum, downloadNum, cancelNum}) => {
    const chartRef = useRef()
    const domRef = useRef()
    const config = useMemo(() => {
        return {
            title: {
                text: '验收中的图片状态',
                top: 30,
                left: 240,
                textStyle: {
                    fontSize: 14,
                }
            },
            tooltip: {
                show: false,
            },
            legend: {
                left: 240,
                top: 'center',
                align: "left",
                orient: 'vertical',
                itemGap: 16,
                textStyle: {
                    fontSize: 14,
                }
            },
            color: ["#336FF6", "#69B9FF", "#CCD9E4"],
            series: [{
                name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                center: [127, '50%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: acceptedNum, name: `已通过（${total > 0 ? Math.round(acceptedNum / total * 100) : 0}%）` },
                    { value: processNum, name: `进行中（${total > 0 ? Math.round(processNum / total * 100) : 0}%）` },
                    total > 0 ? { value: cancelNum } : null,
                ]
            }]
        }
    }, [total, acceptedNum, processNum, cancelNum])

    useEffect(() => {
        const onResize = () => {
            chartRef.current && chartRef.current.resize()
        }
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
            if (chartRef.current) {
                chartRef.current.dispose()
                chartRef.current = null
            }
        }
    }, [])
    useEffect(() => {
        if (!chartRef.current) {
            chartRef.current = echarts.init(domRef.current)
        }
        chartRef.current.setOption(config, {notMerge: true})
    }, [config])

    return (
        <div className={styles.DashboardData}>
            <div className={styles.DashboardDataInfo}>
                <div className={styles.DataItem}>
                    <div className={styles.DataNum}>
                        <span>{total}</span>
                        <span className={styles.DataNumDesc}>张</span>
                    </div>
                    <div className={styles.DataDesc}>累计交付</div>
                </div>
                <div className={styles.DataItem}>
                    <div className={styles.DataNum}>
                        <span>{acceptedNum}</span>
                        <span className={styles.DataNumDesc}>张</span>
                    </div>
                    <div className={styles.DataDesc}>已通过</div>
                </div>
                <div className={styles.DataItem}>
                    <div className={styles.DataNum}>
                        <span>{processNum}</span>
                        <span className={styles.DataNumDesc}>张</span>
                    </div>
                    <div className={styles.DataDesc}>进行中</div>
                </div>
                <div className={styles.DataItem}>
                    <div className={styles.DataNum}>
                        <span>{downloadNum}</span>
                        <span className={styles.DataNumDesc}>张</span>
                    </div>
                    <div className={styles.DataDesc}>已下载</div>
                </div>
            </div>
            <div className={styles.DashboardDataChart}>
                <div ref={domRef} style={{ height: '100%' }}></div>
            </div>
        </div>
    )
}

export default function Dashboard () {
    const {globalUser} = useContext(AppContext)
    const navigate = useNavigate();
    // 数据
    const [loading, setLoading] = useState(false)
    const [dashboardInfo, setDashboardInfo] = useState()
    const [dataSource, setDataSource] = useState([])
    const [pageIndex, setPageIndex] = useState(1)
    const [pageSize, setPageSize] = useState(30)
    const [total, setTotal] = useState(0)
    const [sortInfo, setSortInfo] = useState({})
    // 待交付
    const [loading2, setLoading2] = useState(false)
    const [dataSource2, setDataSource2] = useState([])
    const [pageIndex2, setPageIndex2] = useState(1)
    const [pageSize2, setPageSize2] = useState(30)
    const [total2, setTotal2] = useState(0)
    const [sortInfo2, setSortInfo2] = useState({})
    // 筛选条件
    const [dateType, setDateType] = useState('delivery')
    const [deliveryType, setDeliveryType] = useState('all')
    const [begin, setBegin] = useState()
    const [end, setEnd] = useState(dayjs())
    const [inited, setInited] = useState(false)
    const [force, updateForce] = useState(false)
    // 初始化注册时间
    useEffect(() => {
        if (globalUser?.registerTime) {
            setBegin(dayjs(globalUser.registerTime))
            setInited(true)
        }
    }, [globalUser])
    // 日期格式化
    const customFormat = useCallback(value => {
        if (dayjs().isSame(value, 'day')) {
            return "至今"
        } else {
            return value.format('YYYY/MM/DD')
        }
    }, [])
    useEffect(() => {
        if (!inited) return
        const params = new URLSearchParams()
        // 交付类型
        if (deliveryType == "image") {
            params.append('deliveryMediaType', 0)
        } else if (deliveryType == "video") {
            params.append('deliveryMediaType', 1)
        }
        // 日期类型
        if (dateType == 'delivery') {
            if (begin) params.append('deliveryStart', dayjs(begin).startOf('day').unix())
            if (end) params.append('deliveryEnd', dayjs(end).endOf('day').unix())
        } else {
            if (begin) params.append('completedStart', dayjs(begin).startOf('day').unix())
            if (end) params.append('completedEnd', dayjs(end).endOf('day').unix())
        }
        commonApiInvoker(API.getDashboardInfo(params), false, true).then(res => {
            setDashboardInfo(res)
        }).catch(err => {
            console.error(err)
            setDashboardInfo()
        })
    }, [inited, dateType, deliveryType, begin, end, force])
    // fetch数据
    useEffect(() => {
        if (!inited) return
        const params = new URLSearchParams()
        params.append('pageIndex', pageIndex)
        params.append('pageSize', pageSize)
        // 排序
        if (sortInfo && sortInfo.field) {
            const field = sortInfo.field
            const order = sortInfo.order == 'ascend' ? 'asc' : 'desc'
            params.append('sortField', field)
            params.append('order', order)
        }
        // 交付类型
        if (deliveryType == "image") {
            params.append('deliveryMediaType', 0)
        } else if (deliveryType == "video") {
            params.append('deliveryMediaType', 1)
        }
        // 日期类型
        if (dateType == 'delivery') {
            if (begin) params.append('deliveryStart', dayjs(begin).startOf('day').unix())
            if (end) params.append('deliveryEnd', dayjs(end).endOf('day').unix())
        } else {
            if (begin) params.append('completedStart', dayjs(begin).startOf('day').unix())
            if (end) params.append('completedEnd', dayjs(end).endOf('day').unix())
        }
        setLoading(true)
        commonApiInvoker(API.getDashboardList(params), false, true).then(res => {
            setDataSource((res.items || []).map((item, index) => ({
                ...item,
                index: (pageIndex - 1) * pageSize + index + 1,
            })))
            setTotal(res.total || 0)
        }).catch(err => {
            console.error(err)
            setDataSource([])
            setTotal(0)
        }).finally(() => {
            setLoading(false)
        })
    }, [inited, dateType, deliveryType, begin, end, pageIndex, pageSize, sortInfo, force])
    // 待交付数据
    useEffect(() => {
        if (!inited) return
        const params = new URLSearchParams()
        params.append('pageIndex', pageIndex2)
        params.append('pageSize', pageSize2)
        // 排序
        if (sortInfo2 && sortInfo2.field) {
            const field = sortInfo2.field
            const order = sortInfo2.order == 'ascend' ? 'asc' : 'desc'
            params.append('sortField', field)
            params.append('order', order)
        }
        setLoading2(true)
        commonApiInvoker(API.getRequirementPending(params), false, true).then(res => {
            setDataSource2((res.items || []).map((item, index) => ({
                ...item,
                index: (pageIndex2 - 1) * pageSize2 + index + 1,
            })))
            setTotal2(res.total || 0)
        }).catch(err => {
            console.error(err)
            setDataSource2([])
            setTotal2(0)
        }).finally(() => {
            setLoading2(false)
        })
    }, [inited, pageIndex2, pageSize2, sortInfo2, force])
    // 查看详情
    const handleView = useCallback((record) => {
        const searchParams = new URLSearchParams();
        searchParams.append('version', record.deliveryVersion)
        navigate(`/home/homemain/masterDeliver?${searchParams.toString()}`)
    }, [])
    // 查看待交付单详情
    const [open, setOpen] = useState(false)
    const [recordId, setRecordId] = useState()
    const [readOnly, setReadOnly] = useState(true)
    const handleView2 = useCallback((record) => {
        setReadOnly(true)
        setRecordId(record.id)
        setOpen(true)
    }, [])
    // 编辑待交付单
    const handleEdit = useCallback((record) => {
        setReadOnly(false)
        setRecordId(record.id)
        setOpen(true)
    }, [])
    // 取消编辑
    const handleCancel = useCallback(() => {
        eventBus.emit('requirementForm:edited', () => {
            setOpen(false)
            updateForce({})
        })
    }, [])
    // 提交编辑
    const handleSubmitOk = useCallback(() => {
        setOpen(false)
        updateForce({})
    }, [])
    // 表格分页
    const handleTableChange = useCallback((pagination, filters, sorter) => {
        const { current, pageSize } = pagination
        setPageIndex(current)
        setPageSize(pageSize)
        setSortInfo(sorter)
    }, [])
    const handleTableChange2 = useCallback((pagination, filters, sorter) => {
        const { current, pageSize } = pagination
        setPageIndex2(current)
        setPageSize2(pageSize)
        setSortInfo2(sorter)
    }, [])
    // 表格列
    const columns = useMemo(() => [{
        dataIndex: 'index',
        key: 'index',
        width: 50,
        render: text => (
            <span style={{fontSize:"13px", color:"rgba(0, 0, 0, 0.2)"}}>{text}</span>
        ),
    }, {
        title: '交付版本',
        dataIndex: 'deliveryVersion',
        key: 'deliveryVersion',
        minWidth: 300,
        render: text => (
            <div title={text} style={{minWidth: 300, maxWidth: 500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>{text}</div>
        )
    }, {
        title: '交付日期',
        dataIndex: 'deliveredTime',
        key: 'deliveredTime',
        render: text => text ? dayjs(text).format('YYYY/MM/DD') : '-',
        sorter: true,
        sortOrder: sortInfo.columnKey == 'deliveredTime' ? sortInfo.order : null,
    }, {
        title: '完结日期',
        dataIndex: 'completedTime',
        key: 'completedTime',
        render: text => text ? dayjs(text).format('YYYY/MM/DD') : '-',
        sorter: true,
        sortOrder: sortInfo.columnKey == 'completedTime' ? sortInfo.order : null,
    }, {
        title: '交付总数',
        dataIndex: 'deliveryNum',
        key: 'deliveryNum',
    }, {
        title: '已通过总数',
        dataIndex: 'acceptedNum',
        key: 'acceptedNum',
    }, {
        title: '进行中总数',
        dataIndex: 'processNum',
        key: 'processNum',
    }, {
        title: '已通过/进行中',
        key: 'progress',
        fixed: 'right',
        render: (_, record) => {
            const deliveryNum = record.deliveryNum || 0
            const acceptedNum = record.acceptedNum || 0
            const processNum = record.processNum || 0
            const cancelNum = record.cancelNum || 0
            return (
                <ProgressComponent
                    deliveryNum={deliveryNum}
                    acceptedNum={acceptedNum}
                    processNum={processNum}
                    cancelNum={cancelNum}
                />
            )
        }
    }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        fixed: 'right',
        render: text => (
            <span style={{
                display:"inline-block",
                width: "56px",
                height: "28px",
                fontSize: "13px",
                lineHeight: "28px",
                backgroundColor: text == 0 ? "rgba(105, 185, 255, 0.1)" : "rgba(130, 151, 212, 0.1)",
                color: text == 0 ? "#1284E7" : "rgba(0, 0, 0, 0.5)",
                textAlign: "center",
                borderRadius: "8px",
            }}>{text == 0 ? "进行中" : "已完成"}</span>
        )
    }, {
        title: '操作',
        key: 'action',
        fixed: 'right',
        render: (_, record) => (
            <Button type='link' size='small' onClick={() => handleView(record)}>查看</Button>
        )
    }], [sortInfo, handleView])
    const columns2 = useMemo(() => [{
        dataIndex: 'index',
        key: 'index',
        width: 50,
        render: text => (
            <span style={{fontSize:"13px", color:"rgba(0, 0, 0, 0.2)"}}>{text}</span>
        ),
    }, {
        title: '批次名',
        dataIndex: 'deliveryVersion',
        key: 'deliveryVersion',
        minWidth: 300,
        render: text => (
            <div title={text} style={{minWidth: 300, maxWidth: 500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>{text}</div>
        )
    }, {
        title: '提交日期',
        dataIndex: 'submittedTime',
        key: 'submittedTime',
        render: text => text ? dayjs(text).format('YYYY/MM/DD HH:mm:ss') : '-',
        sorter: true,
        sortOrder: sortInfo2.columnKey == 'submittedTime' ? sortInfo2.order : null,
    }, {
        title: '需求总数',
        dataIndex: 'imageCount',
        key: 'imageCount',
    }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        fixed: 'right',
        render: text => (
            <span style={{
                display:"inline-block",
                width: "56px",
                height: "28px",
                fontSize: "13px",
                lineHeight: "28px",
                backgroundColor: text == -2 ? "rgba(130, 151, 212, 0.1)" : "rgba(105, 185, 255, 0.1)",
                color: text == -2 ? "rgba(0, 0, 0, 0.5)" : "#2DB59E",
                textAlign: "center",
                borderRadius: "8px",
            }}>{text == -2 ? "待接单" : "制作中"}</span>
        )
    }, {
        title: '操作',
        key: 'action',
        fixed: 'right',
        render: (_, record) => (
            record.status == -2 ?
            <Button type='link' size='small' onClick={() => handleEdit(record)}>编辑</Button> :
            <Button type='link' size='small' onClick={() => handleView2(record)}>查看</Button>
        )
    }], [sortInfo2, handleEdit, handleView2])

    const disabledDate = useCallback(current => {
        // Can not select days before registerTime
        if (globalUser) {
            return current && current < dayjs(globalUser.registerTime).startOf('day');
        } else {
            return false
        }
    }, [globalUser])
    const renderExtraFooter = useCallback(() => {
        const setThisWeek = () => {
            if (disabledDate(dayjs().startOf('week'))) {
                setBegin(dayjs(globalUser.registerTime).startOf('day'))
            } else {
                setBegin(dayjs().startOf('week'))
            }
            setEnd(dayjs().endOf('week'))
        }
        const setThisMonth = () => {
            if (disabledDate(dayjs().startOf('month'))) {
                setBegin(dayjs(globalUser.registerTime).startOf('day'))
            } else {
                setBegin(dayjs().startOf('month'))
            }
            setEnd(dayjs().endOf('month'))
        }
        const setLastWeek = () => {
            if (disabledDate(dayjs().subtract(7, 'day'))) {
                setBegin(dayjs(globalUser.registerTime).startOf('day'))
            } else {
                setBegin(dayjs().subtract(7, 'day'))
            }
            setEnd(dayjs())
        }
        const setLastMonth = () => {
            if (disabledDate(dayjs().subtract(30, 'day'))) {
                setBegin(dayjs(globalUser.registerTime).startOf('day'))
            } else {
                setBegin(dayjs().subtract(30, 'day'))
            }
            setEnd(dayjs())
        }
        return (
            <Space style={{margin: "10px 0"}}>
                <Button style={{fontSize: 12}} shape="round" size='small' onClick={setThisWeek}>本周</Button>
                <Button style={{fontSize: 12}} shape="round" size='small' onClick={setThisMonth}>本月</Button>
                <Button style={{fontSize: 12}} shape="round" size='small' onClick={setLastWeek}>近1周</Button>
                <Button style={{fontSize: 12}} shape="round" size='small' onClick={setLastMonth}>近1月</Button>
            </Space>
        )
    }, [disabledDate])

    const location = useLocation()
    const [activeKey, setActiveKey] = useState(location.hash.replace('#', '') || 'delivered')
    const activeKeyChange = useCallback((value) => {
        setActiveKey(value)
        navigate({ hash: `#${value}` })
    }, [])

    const filterDisabled = useMemo(() => {
        return activeKey == 'pending'
    }, [activeKey])

    return (
        <div className={styles.Dashboard}>
            <div className={styles.DashboardTop}>
                <Space.Compact>
                    <Select
                        disabled={filterDisabled}
                        style={{width: 106}}
                        classNames={{
                            root: styles.SearchSelect,
                            popup: {
                                root: styles.SearchSelectPopup
                            }
                        }}
                        options={dateTypeOptions}
                        value={dateType}
                        onChange={value => {
                            setDateType(value)
                            setPageIndex(1)
                        }}
                    />
                    <DatePicker.RangePicker
                        disabled={filterDisabled}
                        style={{width: 214}}
                        classNames={{
                            root: styles.SearchDatePicker,
                            popup: {
                                root: styles.SearchDatePickerPopup
                            }
                        }}
                        allowClear={false}
                        format={customFormat}
                        value={[begin, end]}
                        disabledDate={disabledDate}
                        renderExtraFooter={renderExtraFooter}
                        onChange={([begin, end]) => {
                            setPageIndex(1)
                            setBegin(begin)
                            setEnd(end)
                        }}
                    />
                </Space.Compact>
                <Select
                    disabled={filterDisabled}
                    style={{width: 132, marginLeft: 16}}
                    classNames={{
                        root: styles.SearchSelect,
                        popup: {
                            root: styles.SearchSelectPopup
                        }
                    }}
                    options={deliveryTypeOptions}
                    value={deliveryType}
                    onChange={value => {
                        setDeliveryType(value)
                        setPageIndex(1)
                    }}
                />
            </div>
            <div className={styles.DashboardData}>
                <DashboardData
                    total={dashboardInfo?.deliveryNum || 0}
                    acceptedNum={dashboardInfo?.acceptNum || 0}
                    processNum={dashboardInfo?.processNum || 0}
                    downloadNum={dashboardInfo?.downloadNum || 0}
                    cancelNum={dashboardInfo?.cancelNum || 0}
                />
            </div>
            <div className={styles.DashboardTable}>
                <Tabs
                    size="small"
                    className={styles.tabs}
                    styles={{
                        root: {height: "100%"}
                    }}
                    items={[{
                        label: '已交付',
                        key: 'delivered',
                        children: <Table
                            className="customTable"
                            rowKey={"deliveryVersion"}
                            loading={loading}
                            dataSource={dataSource}
                            columns={columns}
                            onChange={handleTableChange}
                            pagination={{
                                total,
                                current: pageIndex,
                                pageSize,
                                showSizeChanger: true,
                                pageSizeOptions: [10, 20, 30, 40],
                                placement: ['bottomCenter']
                            }}
                            scroll={{
                                x: 'max-content',
                                y: `max-content`,
                            }}
                        />
                    }, {
                        label: '待交付',
                        key: 'pending',
                        children: <Table
                            className="customTable"
                            rowKey={"index"}
                            loading={loading2}
                            dataSource={dataSource2}
                            columns={columns2}
                            onChange={handleTableChange2}
                            pagination={{
                                total: total2,
                                current: pageIndex2,
                                pageSize: pageSize2,
                                showSizeChanger: true,
                                pageSizeOptions: [10, 20, 30, 40],
                                placement: ['bottomCenter']
                            }}
                            scroll={{
                                x: 'max-content',
                                y: `max-content`,
                            }}
                        />
                    }]}
                    activeKey={activeKey}
                    onChange={activeKeyChange}
                />
            </div>
            <Modal
                open={open}
                footer={null}
                mask={{closable: true}}
                closeIcon={false}
                destroyOnHidden
                onCancel={handleCancel}
                width="100vw"
                style={{ top: 0, maxWidth: '100vw'}}
                styles={{
                    wrapper: { overflow: "hidden" },
                    container: {padding: 0, borderRadius: 0},
                    content: { padding: 0, borderRadius: 0 },
                    body: { height: "100vh", overflow: "hidden" }
                }}
            >
                <div style={{position:"relative", width: "100%", height:"100%"}}>
                    <RequirementForm
                        recordId={recordId}
                        readOnly={readOnly}
                        draftDisabled={true}
                        onSubmitOk={handleSubmitOk}
                    />
                    <Button style={{position:"absolute", left: 24, top: 24}} icon={<ArrowLeftOutlined />} onClick={handleCancel}>返回</Button>
                </div>
            </Modal>
        </div>
    )
}